import {
  auth as firebaseAuth,
  firestore as db,
  storage,
} from '../firebaseInit';

// import firebase from 'firebase';
// // import * as firebase from 'firebase';
// import 'firebase/firestore';

// firebase.initializeApp(firebaseConfig);

// const firebaseAuth = firebase.auth;
// const db = firebase.firestore();
// const storage = firebase.storage;
// export const firestore = firebase.firestore();
// export const firebaseAuth = firebase.auth;
// export const storage = firebase.storage;

// import {
//   auth as firebaseAuth,
//   firestore as db,
//   storage,
// } from "../firebaseInit";

// auth
const authInstance = firebaseAuth();

export const signInWithEmailAndPassword = async (email, password) => {
  const response = await authInstance.signInWithEmailAndPassword(
    email,
    password
  );
  return response;
};

export const signOut = () => {
  authInstance.signOut();
};

export const onAuthStateChanged = (callback) => {
  authInstance.onAuthStateChanged((auth) => {
    callback(auth);
  });
};

// db
export const createDocument = async (collectionName, doc) => {
  await db.collection(collectionName).add(doc);
};

// https://firebase.google.com/docs/firestore/query-data/queries
// query: e.g. ['status', '==', 'active']
export const fetchDocuments = async (collectionName, query) => {
  let snapshot;
  if (query) {
    snapshot = await db
      .collection(collectionName)
      .where(...query)
      .get();
  } else {
    snapshot = await db.collection(collectionName).get();
  }
  return snapshot.docs.map((doc) => {
    return { id: doc.id, content: doc.data() };
  });
};

export const updateDocument = async (collectionName, docId, doc) => {
  const docRef = await db.collection(collectionName).doc(docId);
  await docRef.update(doc);
};

// storage
const storageInstance = storage();
const storageRef = storageInstance.ref();

export const uploadFile = async (
  directoryName,
  fileName,
  file,
  contentType
) => {
  const fileRef = storageRef.child(`${directoryName}/${fileName}`);
  try {
    await fileRef.put(file, { contentType });
    const fileDownloadURL = await fileRef.getDownloadURL();
    return fileDownloadURL;
  } catch (error) {
    console.log(error);
  }
};

export const fetchFilesList = async (directoryName) => {
  const listRef = storageRef.child(directoryName);
  const res = await listRef.listAll();
  const filesList = await Promise.all(
    res.items.map(async (itemRef) => {
      const fileDownloadURL = await itemRef.getDownloadURL();
      const fileName = itemRef.name;
      return { fileName, fileDownloadURL };
    })
  );
  return filesList;
};
